module.exports = __webpack_public_path__ + "static/img/linkedin.157d179a.png";